"use client";

import { useInteractions } from "../../../hooks/interactionsProvider";
import { Textarea } from "@/components/ui/textarea";
import { t } from "@/lib/localization";

export default function ClozeInteractionContent() {
    const { selectedInteraction, updateInteraction } = useInteractions();

    if (!selectedInteraction || selectedInteraction.type !== "cloze")
        return <></>;

    const updateText = (newText: string) => {
        updateInteraction(selectedInteraction.id, {
            content: {
                ...selectedInteraction.content,
                text: newText,
            },
        });
    };

    return (
        <div className="flex flex-col gap-2">
            <div className="flex flex-col gap-2">
                <Textarea
                    value={selectedInteraction.content.text}
                    onChange={(e) => updateText(e.target.value)}
                />
            </div>
        </div>
    );
}
